﻿package com.mgacreative.hotelru.feature.channelmanager.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.domain.model.Agency
import com.mgacreative.hotelru.domain.model.AgencyAllotment
import com.mgacreative.hotelru.domain.repository.AgencyRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class AgencyAllotmentViewModel(
    private val agencyRepository: AgencyRepository
) : ViewModel() {

    private val _agencies = MutableStateFlow<List<Agency>>(emptyList())
    val agencies: StateFlow<List<Agency>> = _agencies.asStateFlow()

    private val _allotments = MutableStateFlow<List<AgencyAllotment>>(emptyList())
    val allotments: StateFlow<List<AgencyAllotment>> = _allotments.asStateFlow()

    private val _isLoading = MutableStateFlow(false)
    val isLoading: StateFlow<Boolean> = _isLoading.asStateFlow()

    private val _errorMessage = MutableStateFlow<String?>(null)
    val errorMessage: StateFlow<String?> = _errorMessage.asStateFlow()

    init {
        loadData()
    }

    private fun loadData() {
        viewModelScope.launch {
            _isLoading.value = true
            try {
                _agencies.value = agencyRepository.getAgencies()
                _allotments.value = agencyRepository.getAllotments()
            } catch (e: Exception) {
                _errorMessage.value = "Veriler yüklenirken hata oluştu: ${e.message}"
            } finally {
                _isLoading.value = false
            }
        }
    }

    fun refresh() {
        loadData()
    }

    fun createAllotment(agencyId: String, startDate: String, endDate: String, rooms: Int) {
        viewModelScope.launch {
            _isLoading.value = true
            try {
                val allotment = AgencyAllotment(
                    agencyId = agencyId,
                    startDate = startDate,
                    endDate = endDate,
                    allottedRooms = rooms
                )
                agencyRepository.createAllotment(allotment)
                _allotments.value = agencyRepository.getAllotments()
                _errorMessage.value = null
            } catch (e: Exception) {
                _errorMessage.value = "Kontenjan ayrılamadı: ${e.message}"
            } finally {
                _isLoading.value = false
            }
        }
    }

    fun clearError() {
        _errorMessage.value = null
    }
}

